import { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';

/**
 * Free-text list editor used for complaints, diagnosis, allergies and advice.
 * Enter adds the value, the x on a chip removes it.
 */
export default function TagInput({
  value = [],
  onChange,
  placeholder = 'Type and press Enter',
  suggestions = [],
  disabled,
}) {
  const [draft, setDraft] = useState('');

  function add(text) {
    const clean = String(text).trim();
    if (!clean) return;
    if (value.some((v) => v.toLowerCase() === clean.toLowerCase())) {
      setDraft('');
      return;
    }
    onChange([...value, clean]);
    setDraft('');
  }

  function remove(index) {
    onChange(value.filter((_, i) => i !== index));
  }

  const matches = draft.trim()
    ? suggestions
        .filter(
          (s) =>
            s.toLowerCase().includes(draft.trim().toLowerCase()) &&
            !value.some((v) => v.toLowerCase() === s.toLowerCase()),
        )
        .slice(0, 6)
    : [];

  return (
    <div>
      <InputGroup size="sm">
        <Form.Control
          value={draft}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add(draft);
            }
            if (e.key === 'Backspace' && !draft && value.length) remove(value.length - 1);
          }}
        />
        <Button variant="outline-secondary" onClick={() => add(draft)} disabled={disabled || !draft.trim()}>
          <i className="bi bi-plus-lg" />
        </Button>
      </InputGroup>

      {matches.length > 0 && (
        <div className="d-flex flex-wrap gap-1 mt-1">
          {matches.map((s) => (
            <Button key={s} size="sm" variant="outline-secondary" className="py-0 px-2" onClick={() => add(s)}>
              {s}
            </Button>
          ))}
        </div>
      )}

      {value.length > 0 && (
        <div className="d-flex flex-wrap gap-2 mt-2">
          {value.map((item, i) => (
            <span className="tag-chip" key={`${item}-${i}`}>
              {item}
              {!disabled && (
                <button type="button" className="btn-x" onClick={() => remove(i)} aria-label={`Remove ${item}`}>
                  <i className="bi bi-x-lg" style={{ fontSize: '0.7rem' }} />
                </button>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
